// UI components
import Navbar from './ui/Navbar'
import PageHeader from './ui/PageHeader'
import VButton from './ui/VButton'
import VFooter from './ui/VFooter'

// Icons
import Icon from './icons/Icon'
import IconCar from './icons/IconCar'
import IconClose from './icons/IconClose'
import IconClothes from './icons/IconClothes'
import IconDown from './icons/IconDown'
import IconFacebook from './icons/IconFacebook'
import IconFire from './icons/IconFire'
import IconFood from './icons/IconFood'
import IconLocation from './icons/IconLocation'
import IconMail from './icons/IconMail'
import IconMenu from './icons/IconMenu'
import IconPhone from './icons/IconPhone'
import IconSquare from './icons/IconSquare'
import IconTv from './icons/IconTv'
import IconWater from './icons/IconWater'

export default [
  // UI components
  Navbar,
  PageHeader,
  VFooter,
  VButton,
  // Icons
  Icon,
  IconCar,
  IconClose,
  IconClothes,
  IconDown,
  IconFacebook,
  IconFire,
  IconFood,
  IconLocation,
  IconMail,
  IconMenu,
  IconPhone,
  IconSquare,
  IconTv,
  IconWater
]



// WEBPACK FOOTER //
// ./src/components/components.js